import { createFormContext } from "@mantine/form";
import type { Place } from "place/types/place.model";

export const [PlaceFormProvider, usePlaceFormContext, usePlaceForm] =
  createFormContext<Omit<Place, "id">>();
